import React, { Fragment, useContext } from "react";
import { Button, Checkbox, Dimmer, Form, Loader } from "semantic-ui-react";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import RichTextEditorField from "./components/RichTextEditorField";
import TextField from "./components/TextField";
import Layout from "../Layout/LayoutContainer";
import { emailEventType } from "./types";
import TabEmail from "./components/TabEmail";
import TabPreferences from "./components/TabPreferences";
import TabSMS from "./components/TabSMS";
import { LayoutContext } from "../../context/LayoutContext";
import TabListView from "../TabListView";
import TabNotification from "./components/TabNotification";

interface EntityForm {
  file: File;
  entityName: string;
  entityEmailConfirmationBody: string;
  entityEmailLinkBody: string;
  entitySmsConfirmationBody: string;
}

interface Props {
  emailEventFields: emailEventType;
  onChangeFields: (x: any) => void;
  decodeMessages: (x: emailEventType) => void;
  init: () => void;
  loading: boolean;
  values: any;
  organitzationURL: string;
  setOrganitzationURL: (x: string) => void;
  organitzationURLInformers: string;
  setOrganitzationURLInformers: (x: string) => void;
  isRecording: boolean;
  updateRecordingsForOrganization: () => void;
  historyHandleClick: () => void;
  handleSubmit: () => void;
  updateInformersNamesForArea : () => void;
  showName: boolean;
  setGenericInformersName : (x: string) => void;
  genericInformersName : string;
  sendExtern: boolean;
  updateSendExternNotifications: () => void;
  organitzationNotification: boolean;
}

export default (props: Props) => {
  const { t } = useTranslation();
  const layoutContext = useContext(LayoutContext);
  const { setTitle, setBreadcrumb } = layoutContext;

  useEffect(() => {
    setTitle(t("area.personalitzation.title"));
    setBreadcrumb([
      {
        name: t("area.title"),
        link: "/area",
      },
      {
        name: t("area.personalitzation.title"),
        link: "/area/settings",
      },
    ]);
    props.init();
  }, [t, setTitle, setBreadcrumb]);

  const {
    entityEmailConfirmationBody,
    entityEmailLinkBody,
    entitySmsConfirmationBody,
  } = props.values as EntityForm;
  return (
    <>
      {props.loading ? (
        <Loader active inline="centered" content="Loading" size="medium">
          {t("loading.defect")}
        </Loader>
      ) : (
        <Layout.FullScreen>
          <Form>
            <TabListView
              className="mb-4"
              tabsConfig={[
                {
                  title: t("area.personalitzation.tab_notification"),
                  accessor: "notification",
                  contentView: (
                    <TabNotification
                      onChangeFields={props.onChangeFields} 
                      sendExtern={props.sendExtern}
                      updateSendExternNotifications={props.updateSendExternNotifications}
                      organitzationNotification={props.organitzationNotification}
                    />

                  ),
                },
                {
                  title: t("area.personalitzation.tab_email"),
                  accessor: "email",
                  contentView: (
                    <TabEmail
                      onChangeFields={props.onChangeFields}
                      emailEventFields={props.emailEventFields}
                    />
                  ),
                },
                {
                  title: t("area.personalitzation.tab_sms"),
                  accessor: "sms",
                  contentView: (
                    <TabSMS
                      onChangeFields={props.onChangeFields}
                      emailEventFields={props.emailEventFields}
                    />
                  ),
                },
                {
                  title: t("area.personalitzation.tab_preferences"),
                  accessor: "preferences",
                  contentView: (
                    <TabPreferences
                      organitzationURL={props.organitzationURL}
                      setOrganitzationURL={props.setOrganitzationURL}
                      organitzationURLInformers={
                        props.organitzationURLInformers
                      }
                      setOrganitzationURLInformers={
                        props.setOrganitzationURLInformers
                      }
                      updateRecordingsForOrganization={
                        props.updateRecordingsForOrganization
                      }                      
                      isRecording={props.isRecording}
                      updateInformersNamesForArea={props.updateInformersNamesForArea}
                      showName={props.showName}
                      setGenericInformersName={props.setGenericInformersName}
                      genericInformersName={props.genericInformersName}
                    />
                  ),
                },
              ]}
            />

            <Button
              style={{ backgroundColor: "#cfe1ff" }}
              content={t("go_back")}
              icon="left arrow"
              labelPosition="left"
              onClick={props.historyHandleClick}
            />

            <Button submit positive onClick={props.handleSubmit} >
              {t("area.personalitzation.button")}
            </Button>
          </Form>
        </Layout.FullScreen>
      )}
    </>
  );
};
